import ApiService from "@/service/ApiService";

export default function useApi() {


  const getDatas = async () => {
    return await ApiService.get("get_registration_departments");
  };

  const stoerData = async (data) => {
    return await ApiService.post("registration_queue", data);
   };
 

  return {
    getDatas,
    stoerData
   
  };
}
